import {
  getYear,
  getStartYearRange,
  getEndYearRange,
} from "../../../utils/general";
import classOptions from "./classOptions";
import levelOptions from "./level";

let FromDetails = {
  //Page 1
  primaryDetails: {
    usb_inititalagreement: {
      elementType: "checkbox",
      elementConfig: {
        label: "Oui*",
        name: "usb_inititalagreement",
      },
      value: false,
      required: true,
    },
  },
  //Page 2
  nameCitizenshipDetails: {
    lastname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Legal Last Name* ",
        autoComplete: "lastname",
        name: "lastname",
        fullWidth: true,
        disabled: false,
      },
      value: "",
    },
    firstname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Legal First Name* ",
        autoComplete: "firstname",
        name: "firstname",
        fullWidth: true,
        disabled: false,
      },
      value: "",
    },
    ses_preferredname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Preferred Name ",
        autoComplete: "ses_preferredname",
        name: "ses_preferredname",
        fullWidth: true,
      },
      value: "",
    },
    middlename: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Legal Middle Name ",
        autoComplete: "middlename",
        name: "middlename",
        fullWidth: true,
        disabled: false,
      },
      value: "",
    },
    usb_maidenname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Maiden Name",
        autoComplete: "usb_maidenname",
        name: "usb_maidenname",
        fullWidth: true,
      },
      value: "",
    },
    usb_formername: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Former Name",
        autoComplete: "usb_formername",
        name: "usb_formername",
        fullWidth: true,
      },
      value: "",
    },
    usb_visastatus: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Citizenship Status*",
        name: "usb_visastatus",
        options: [
          { value: 943240000, displayValue: "Canadian Citizen" }, 
          { value: 943240001, displayValue: "Permanent Resident" }, 
          { value: 943240005, displayValue: "Refugee" }, 
          { value: 943240003, displayValue: "Study permit" },
          // { value: 943240002, displayValue: "Work Permit" }, // International
          // {
          //   value: 943240006, // International
          //   displayValue: "Non-resident (without study permit)",
          // }, //International without study permit
          // {
          //   value: 943240004, // Domestic
          //   displayValue: "Minnesota Reciprocity Program - Study Permit",
          // }, //International with study permit,
        ],
      
      },
      value: "",
    },
    usb_previouslyapplied: {
      elementType: "select",
      elementConfig: {
        type: "text",
        aboveText: "Have you previously applied to USB?*",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        name: "usb_previouslyapplied",
          display: "block",
      },
      value: "",
    },
    usb_mostrecentpreviousapplicationyear: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label:
          "Which year?* If you have applied more than once, please indicate the most recent year.",
        options: getYear(),
        name: "usb_mostrecentpreviousapplicationyear",
        display: "none",
      },
      value: "",
    },
    usb_currentstudent: {
      elementType: "select",
      elementConfig: {
        label: "Are you a current USB student?*",
        name: "usb_currentstudent",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        display: "none",
      },
      maxLength: 80,
      isValid: false,
      value: "",
    },
    _usb_countryofcitizenship_value: {
      elementType: "select",
      elementConfig: {
        label: "Country of Citizenship*",
        name: "_usb_countryofcitizenship_value",
        options: [],
      },
      maxLength: 80,
      isValid: false,
      value: "",
    },
    _usb_countryofbirth_value: {
      elementType: "select",
      elementConfig: {
        label: "Country of Birth*",
        name: "_usb_countryofbirth_value",
        options: [],
      },
      maxLength: 80,
      isValid: false,
      value: "",
    },
    usb_passport: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Passport*",
        autoComplete: "usb_passport",
        name: "usb_passport",
        fullWidth: true,
      },
      value: "",
      display: "none",
    },
    usb_passportexpirydate: {
      elementType: "date",
      elementConfig: {
        type: "text",
        label: "Passport Expiry Date*",
        name: "usb_passportexpirydate",
        fullWidth: true,
        autoComplete: "off",
        InputLabelProps: {
          shrink: true,
        },
        autoFocus: false,
      },
      value: "",
      allowFutureDates: true,
      display: "none",
    },
    usb_studypermitnumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Study or Work Permit No.",
        autoComplete: "usb_studypermitnumber",
        name: "usb_studypermitnumber",
        fullWidth: true,
      },
      value: "",
      display: "none",
    },

    usb_studypermitissuedate: {
      elementType: "date",
      elementConfig: {
        label: "Study or Work Permit Issue Date",
        name: "usb_studypermitissuedate",
        fullWidth: true,
        autoComplete: "off",
        InputLabelProps: {
          shrink: true,
        },
        autoFocus: false,
      },
      value: "",
      allowFutureDates: true,
      display: "none",
    },
    usb_studypermitexpirydate: {
      elementType: "date",
      elementConfig: {
        label: "Study or Work Permit Expiry Date",
        name: "usb_studypermitexpirydate",
        fullWidth: true,
        autoComplete: "off",
        InputLabelProps: {
          shrink: true,
        },
        autoFocus: false,
      },
      value: "",
      allowFutureDates: true,
      display: "none",
    },
  },
  addressContactDetails: {
    _ses_countryofresidence_value: {
      elementType: "select",
      elementConfig: {
        label: "Country*",
        name: "_ses_countryofresidence_value",
        options: [],
      },
      maxLength: 80,
      isValid: false,
      value: "",
    },
    address1_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street",
        autoComplete: "address1_line1",
        name: "address1_line1",
        fullWidth: true,
        belowLabelText:"numéro et nom de rue, case postale, appartement, unité, étage, etc."
      },
      value: "",
      display:"block"
    },
    address1_line2: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street/Apt",
        autoComplete: "address1_line2",
        name: "address1_line2",
        fullWidth: true,
      },
      value: "",
    },
    address1_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "address1_city",
        name: "address1_city",
        fullWidth: true,
      },
      value: "",
    },
    ses_stateorprovince: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "State/Province",
        name: "ses_stateorprovince",
        options:[],
        display: "none",
      },
      value: "",
    },
    address1_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Postal Code",
        autoComplete: "address1_postalcode",
        name: "address1_postalcode",
        fullWidth: true,
      },
      value: "",
      display: "none",
    },
    emailaddress1: {
      elementType: "input",
      elementConfig: {
        type: "email",
        label: "Email*",
        autoComplete: "emailaddress1",
        name: "emailaddress1",
        fullWidth: true,
        disabled: true,
      },
      value: "",
    },
    emailaddress3: {
      elementType: "input",
      elementConfig: {
        type: "email",
        label: "Email Address 2",
        autoComplete: "emailaddress3",
        name: "emailaddress3",
        fullWidth: true,
      },
      value: "",
    },
  },
  telephoneDetails:{
    mobilephone: {
      elementType: "inputNumber",
      elementConfig: {
        type: "number",
        label: "Mobile",
        autoComplete: "mobilephone",
        name: "mobilephone",
        fullWidth: true,
      },
      value: "",
    },
    ses_optinfortextmessages: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        aboveText: "I accept to receive transactional and promotional SMS messages from the University (to the number indicated above).",
        name: "ses_optinfortextmessages",
        display: "none",
      },
      value: "",
    },
    home2: {
      elementType: "inputNumber",
      elementConfig: {
        type: "number",
        label: "Home",
        autoComplete: "home2",
        name: "home2",
        fullWidth: true,
      },
      value: "",
    },
    business2: {
      elementType: "inputNumber",
      elementConfig: {
        type: "number",
        label: "Office",
        autoComplete: "business2",
        name: "business2",
        fullWidth: true,
      },
      value: "",
    },
  },
  //Page 3
  otherInformation: {
    birthdate: {
      elementType: "exactDate",
      elementConfig: {
        type: "text",
        label: "Date of Birth*",
        name: "birthdate",
        fullWidth: true,
        autoComplete: "off",
        disabled: false,
        InputLabelProps: {
          shrink: true,
        },
        autoFocus: false,
      },
      value: "",
    },

    gendercode: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Gender* ",
        options: [
            { value: 2, displayValue: "Female" },
          { value: 1, displayValue: "Male" },
        
          { value: 943240003, displayValue: "Non-binary" },
          { value: 943240010, displayValue: "Transgender" },
          { value: 943240005, displayValue: "Two-spirit" },
          { value: 943240011, displayValue: "Other" },
          { value: 943240009, displayValue: "I prefer not to answer" },
        ],
        name: "gendercode",
      },
      value: "",
    },
    mshied_firstgeneration: {
      elementType: "select",
      elementConfig: {
        type: "text",
        aboveText:
          "Are you First Generation?*  Select yes if your Parents/ Guardians never attended a postsecondary institution (College, University)",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        name: "mshied_firstgeneration",
        display: "block",
      },
      value: "",
    },
    usb_nativelanguage: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Native Language* ",
        options: [
          { value: 943240000, displayValue: "English" },
          { value: 943240001, displayValue: "French" },
          { value: 943240002, displayValue: "English & French" },
          { value: 943240003, displayValue: "Other Language" },
        ],
        name: "usb_nativelanguage",
        fullWidth: true,
      },
      value: "",
    },
    usb_areyouavisibleminority: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Are you a visible minority?",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        name: "usb_areyouavisibleminority",
      },
      value: "",
    },
  },
  otherInformationPart: {
    usb_indigenousancestry: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Do you want to self-declare your Canadian Indigenous ancestry?",
        options: [
          { value: 1, displayValue: "Yes" },
          { value: 0, displayValue: "No" },
        ],
        name: "usb_indigenousancestry",
        display: "none",
      },
      value: "",
    },
    usb_indigenousancestrytype: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "If you answered yes, please choose from the following options.",
        options: [
          { value: 943240000, displayValue: "First Nations" },
          { value: 943240001, displayValue: "Métis" },
          { value: 943240002, displayValue: "Inuk (Inuit)" },
        ],
        name: "usb_indigenousancestrytype",
        display: "none",
      },
      value: "",
    },
  },
  otherInformationRecruitment:{
    _ses_recruiter_value: {
      elementType: "select",
      elementConfig: {
        type: "text",
        aboveText:
          "Did you find out about our university through one of our recruitment agents? If yes, select the recruiter from the list.",
        options: [],
        name: "_ses_recruiter_value",
        display: "block",
      },
      value: "",
    },
  },
  // Page 4
  program: {
    _ses_academicperiodid_value: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Expected Admit Term *",
        options: [],
        name: "_ses_academicperiodid_value",
      },
      value: "",
    },
    _ses_certificationprogramid_value: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Program of Interest 1 *",
        options: [],
        name: "_ses_certificationprogramid_value",
      },
      value: "",
    },
    _usb_certificationprogramid_value: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Programmes d'études - deuxième choix",
        bottomText: "",
        options: [],
        name: "_usb_certificationprogramid_value",
        display: "block",
      },
      value: "",
    },
    usb_admissioncategory: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Admission Category *",
        options: [],
        name: "usb_admissioncategory",
        display: "none",
        bottomText: `(Au besoin, consulte la page 
                            <a
                              href="https://ustboniface.ca/categories-dadmission"
                              target="_blank"
                            >
                              Catégories d'admission
                            </a> 
                            pour déterminer ta catégorie.)`,
      },
      value: "",
    },
  },

  // Area of Interest
  areasofInterestPartOne: {
    usb_areasofinterestandservices: {
      elementType: "multiplecheckbox",
      elementConfig: {
        name: "usb_areasofinterestandservices",
        options: [
          { label: "Academic Advising", value: 943240000 },
          { label: "Artistic and Cultural Activities", value: 943240001 },
          { label: "Gym (Le Sportex)", value: 943240002 },
          { label: "Intramural Sports", value: 943240003 },
          { label: "Peer Mentorship for New Students", value: 943240004 },
          { label: "Student Accessibility Services", value: 943240005 },
          { label: "Student Groups and Associations", value: 943240006 },
          { label: "Student Housing", value: 943240007 },
          {
            label: "Student Media (Newspaper, Radio, Social Media)",
            value: 943240008,
          },
          {
            label: "Support for Wellbeing and Mental Health",
            value: 943240009,
          },
          {
            label:
              "The Competitive Sports Teams: Les Rouges (Basketball, Volleyball, Soccer, Fustal)",
            value: 943240010,
          },
          {
            label: "Tutoring (French, English, Spanish)",
            value: 943240011,
          },
          {
            label: "The student theatre troupe (Les Chiens de soleil)",
            value: 943240012,
          },
        ],
      },
      value: "",
    },
  },
  // Page 5
  highSchoolInfo: {
    usb_graduatefromhighschoolincurrentyear: {
      elementType: "select",
      elementConfig: {
        type: "text",
        aboveText:
          "Do you expect to graduate from a high school in Manitoba during the current academic year? *",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        name: "usb_graduatefromhighschoolincurrentyear",
        display: "block",
      },
      value: "",
    },
    usb_metnumber: {
      elementType: "input",
      elementConfig: {
        type: "number",
        autoComplete: "usb_metnumber",
        name: "usb_metnumber",
        fullWidth: true,
        maxLength: 25,
        aboveText:
          "Provide MET number if you know it (Consult your Manitoba High School if needed )*",
      },
      value: "",
      display: "none",
    },
    usb_schooltype: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Where was the last high school you attended?*",
        options: [
          { value: 943240000, displayValue: "Manitoba" },
          {
            value: 943240001,
            displayValue: "Canadian Province other than Manitoba",
          },
          { value: 943240002, displayValue: "Outside of Canada" },
          { value: 943240005, displayValue: "Homeschool" },
        ],
        name: "usb_schooltype",
      },
      value: "",
    },
    usb_schoolname0: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label:
          "Select the last high school you attended from the list of schools in Manitoba*",
        options: [],
        name: "usb_schoolname0",
        display: "none",
      },
      value: "",
    },
    usb_schoolname1: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label:
          "Select the last high school you attended from the list (In Canada outside of Manitoba)*",
        options: [],
        name: "usb_schoolname1",
        display: "none",
      },
      value: "",
    },
    usb_schoolname2: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label:
          "Select the last high school you attended from the list (outside of Canada)*",
        options: [],
        name: "usb_schoolname2",
        display: "none",
      },
      value: "",
    },
  },
  highSchoolInfoPartTwo: {
    start_date_month: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Month*",
        options: [
          { value: "01", displayValue: "01" },
          { value: "02", displayValue: "02" },
          { value: "03", displayValue: "03" },
          { value: "04", displayValue: "04" },
          { value: "05", displayValue: "05" },
          { value: "06", displayValue: "06" },
          { value: "07", displayValue: "07" },
          { value: "08", displayValue: "08" },
          { value: "09", displayValue: "09" },
          { value: "10", displayValue: "10" },
          { value: "11", displayValue: "11" },
          { value: "12", displayValue: "12" },
        ],
        name: "start_date_month",
      },
      value: "",
    },
    start_date_year: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Year*",
        options: getStartYearRange(),
        name: "start_date_year",
      },
      value: "",
    },
  },
  highSchoolInfoPartThree: {
    end_date_month: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Month*",
        options: [
          { value: "01", displayValue: "01" },
          { value: "02", displayValue: "02" },
          { value: "03", displayValue: "03" },
          { value: "04", displayValue: "04" },
          { value: "05", displayValue: "05" },
          { value: "06", displayValue: "06" },
          { value: "07", displayValue: "07" },
          { value: "08", displayValue: "08" },
          { value: "09", displayValue: "09" },
          { value: "10", displayValue: "10" },
          { value: "11", displayValue: "11" },
          { value: "12", displayValue: "12" },
        ],
        name: "end_date_month",
      },
      value: "",
    },
    end_date_year: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Year*",
        options: getEndYearRange(),
        name: "end_date_year",
      },
      value: "",
    },
    usb_graduate: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Did you graduate?*",
        options: [
          { value: true, displayValue: "Yes" },
          { value: false, displayValue: "No" },
        ],
        name: "usb_graduate",
      },
      value: "",
    },
    usb_graduationdate: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Graduation Year*",
        options: getStartYearRange(),
        name: "usb_graduationdate",
        display: "none",
      },
      value: "",
    },
    usb_addtionalcoursescomment: {
      elementType: "textArea",
      elementConfig: {
        aboveText:
          "If you would like to provide additional information about your high school education (current or previous), you can write it here:",
        name: "usb_addtionalcoursescomment",
      },
      value: "",
      display: "block",
    },
  },
  // Page 6
  postSecondaryInfo: {},
  postSecondaryInfoparttwo: {
    usb_educationlevel: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Education Level *",
        options: [
          { value: 943240000, displayValue: "College" },
          { value: 943240001, displayValue: "University" },
          { value: 943240002, displayValue: "Cégep" },
        ],
        name: "usb_educationlevel",
      },
      value: "",
    },
    usb_schooltype: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Is the school in Canada?*",
        options: [
          { value: 943240003, displayValue: "Yes" },
          { value: 943240004, displayValue: "No" },
        ],
        name: "usb_schooltype",
      },
      value: "",
    },
    usb_secondaryschoolname0: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Select the school from the list of Canadian schools*",
        options: [],
        name: "usb_secondaryschoolname0",
        display: "none",
      },
      value: "",
    },
    usb_secondaryschoolname1: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Select the school from the list (outside of Canada)*",
        options: [],
        name: "usb_secondaryschoolname1",
        display: "none",
      },
      value: "",
    },
    usb_currentdegreestatus: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Current Degree Status*",
        options: [
          { value: 943240000, displayValue: "Currently Studying" },
          { value: 943240001, displayValue: "Graduated" },
          {
            value: 943240002,
            displayValue: "No longer studying and did not graduate",
          },
        ],
        name: "usb_currentdegreestatus",
      },
      value: "",
    },
  },
  postSecondaryInfoPartThree: {
    start_date_month: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Month*",
        options: [
          { value: "01", displayValue: "01" },
          { value: "02", displayValue: "02" },
          { value: "03", displayValue: "03" },
          { value: "04", displayValue: "04" },
          { value: "05", displayValue: "05" },
          { value: "06", displayValue: "06" },
          { value: "07", displayValue: "07" },
          { value: "08", displayValue: "08" },
          { value: "09", displayValue: "09" },
          { value: "10", displayValue: "10" },
          { value: "11", displayValue: "11" },
          { value: "12", displayValue: "12" },
        ],
        name: "start_date_month",
      },
      value: "",
    },
    start_date_year: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Year*",
        options: getStartYearRange(),
        name: "start_date_year",
      },
      value: "",
    },
  },
  postSecondaryInfoPartFour: {
    end_date_month: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Month",
        options: [
          { value: "01", displayValue: "01" },
          { value: "02", displayValue: "02" },
          { value: "03", displayValue: "03" },
          { value: "04", displayValue: "04" },
          { value: "05", displayValue: "05" },
          { value: "06", displayValue: "06" },
          { value: "07", displayValue: "07" },
          { value: "08", displayValue: "08" },
          { value: "09", displayValue: "09" },
          { value: "10", displayValue: "10" },
          { value: "11", displayValue: "11" },
          { value: "12", displayValue: "12" },
        ],
        name: "end_date_month",
      },
      value: "",
    },
    end_date_year: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Year",
        options: getEndYearRange(),
        name: "end_date_year",
      },
      value: "",
    },

    usb_graduationdate: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Graduation Year*",
        options: getStartYearRange(),
        name: "usb_graduationdate",
        display: "none",
      },
      value: "",
    },
  },
  // page 7
  grade12: {
    usb_classcategory: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Class*",
        options: classOptions,
        name: "usb_classcategory",
      },
      value: "",
    },

    usb_otherclasscategory: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Other*",
        autoComplete: "usb_otherclasscategory",
        name: "usb_otherclasscategory",
        fullWidth: true,
      },
      value: "",
      maxLength: 50,
      display: "none",
    },
    usb_level: {
      elementType: "select",
      elementConfig: {
        type: "text",
        label: "Level*",
        options: levelOptions,
        name: "usb_level",
      },
      value: "",
    },
    usb_grade: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Grade*",
        autoComplete: "usb_grade",
        name: "usb_grade",
        fullWidth: true,
      },
      value: "",
    },
  },
  // Page 8
  applicationFee: {
    applicationOptions: {
      elementType: "radio",
      elementConfig: {
        name: "applicationOptions",
        options: [
          {
            label: "Payer les frais de traitement de dossier",
            value: "Fee",
            bold: "yes",
          },
          {
            label: "J'ai un code promotionnel / administratif",
            value: "Coupon",
          },
        ],
        text: `<span style="font-weight: bold;">Codes promotionnels et codes administratifs :</span> <br />
            Si tu as obtenu un code promotionnel ou un code administratif
            de l’Université de Saint-Boniface, tu peux le saisir ci-dessous. <br /><br />
            Il est important à noter qu’un 
            <span style="font-weight: bold;">
             code promotionnel</span> annule les frais de traitement de dossier tandis qu’un <span style="font-weight: bold;">
             code administratif</span> 
             permet de les payer plus tard. Après avoir soumis ta demande avec un code administratif, le cas échéant, tu auras à payer les frais de traitement 
            de dossier selon les modalités de paiement acceptées par l’Université de Saint-Boniface. Ta demande ne sera pas traitée
            sans que ces frais soient payés.</span>
`,
      },
      value: "",
    },
    usb_couponcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Saisir le code",
        autoComplete: "usb_couponcode",
        name: "usb_couponcode",
        fullWidth: true,
      },
      value: "",
      display: "none",
    },
  },
  // Page 9
  transactionInfo: {
    amountdue: {
      elementType: "input",
      elementConfig: {
        type: "email",
        label: "Amount Due *",
        autoComplete: "amountdue",
        name: "amountdue",
        fullWidth: true,
        disabled: true,
      },
      value: "",
    },
    emailaddress1: {
      elementType: "input",
      elementConfig: {
        type: "email",
        label: "Receipt email *",
        autoComplete: "emailaddress1",
        name: "emailaddress1",
        fullWidth: true,
        disabled: true,
      },
      value: "",
    },
  },
  acknowledgement: {
    usb_termsaccepted: {
      elementType: "checkbox",
      elementConfig: {
        label: "J'accepte les modalités de cette déclaration.*",
        name: "usb_termsaccepted",
      },
      value: false,
      required: true,
    },
    usb_esignature: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "E-signature",
        autoComplete: "usb_esignature",
        name: "usb_esignature",
        fullWidth: true,
        aboveText: "S'il te plait remplir avec ton nom complet.",
      },
      value: "",
      minLength: 3,
    },
    usb_applicationsubmitteddate: {
      elementType: "date",
      elementConfig: {
        type: "text",
        label: "Date*",
        name: "usb_applicationsubmitteddate",
        fullWidth: true,
        autoComplete: "off",
        InputLabelProps: {
          shrink: true,
        },
        autoFocus: false,
        disabled: true,
      },
    },
  },
};

export default FromDetails;
